const types = { 
  herbalkatalog: 'Herbal Katalog',
  supergrosir: 'Super Grosir Herbal',
  dropshipping: 'Dropshipping Herbal'
}

export default (type = '') => types[type]